<template>
    <v-dialog v-model="handleDialog" max-width="800px" @click:outside="cancel">
        <validation-observer ref="obs" v-slot="{ invalid }">
            <v-card color="#F4FEFB">
                <v-card-title class="justify-center">
                    アラート
                </v-card-title>
                
                <v-card-text>
                    
                    <v-container>
                        <template v-if="contractAlertsId != null">
                            <v-row justify="end">
                                <v-btn min-width="100px" class="white--text" color="red" @click="pushDelete">
                                    削除
                                </v-btn>
                            </v-row>
                        </template>
                        <v-row no-gutters>
                            <v-col cols="12" class="mt-5 text-center">
                                設定したアラート日に、書類管理権限をもつ管理者宛てにメールを配信します。
                            </v-col>
                            <v-col cols="12" class="text-center">
                                これにより、契約の更新・解約漏れを防止できます。
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" class="text-center">
                                <div><span class="doc-info">書類情報</span>契約終了日：{{ contractEndDate ? contractEndDate : "設定無し" }}</div>
                                <div class="cancel-notice-deadline">解約通知期限：{{ cancelNoticeDeadline ? cancelNoticeDeadline : "設定無し" }}</div>
                            </v-col>
                        </v-row>
                        <validation-provider v-slot="{ errors }" name="アラート日" rules="required">
                            <v-row>
                                <v-col cols="4">
                                    <badge-component tile content="必　須" color="red" rules="required"><label-component>アラート日</label-component></badge-component>
                                </v-col>
                                <v-col cols="8">
                                    <date-picker-component v-model="alertDateTime"></date-picker-component>
                                </v-col>
                            </v-row>
                        </validation-provider>
                        <validation-provider name="メモ" rules="max:255" v-slot="{ errors }">
                            <v-row>
                                <v-col cols="4">
                                     <badge-component tile content="任　意"><label-component height="112">メモ</label-component></badge-component>
                                </v-col>
                                <v-col cols="8" >
                                    <v-textarea name="memo" outlined background-color="white" v-model="note" rows="4"></v-textarea>
                                </v-col>
                            </v-row>
                        </validation-provider>
                        <validation-provider v-slot="{ errors }" name="アラート" rules="required">
                            <v-row>
                                <v-col cols="4">
                                    <badge-component tile content="必　須" color="red"><label-component>アラート</label-component></badge-component>
                                </v-col>
                                <v-col cols="8">
                                    <v-radio-group row v-model="onOff" >
                                        <v-radio label="ON" color="black" :value="1"></v-radio>
                                        <v-radio label="OFF" color="black" :value="0"></v-radio>
                                        
                                    </v-radio-group>
                                </v-col>
                            </v-row>
                        </validation-provider>
                    </v-container>
                </v-card-text>
                <v-card-actions class="justify-center pb-6">
                    <v-btn min-width="150px" class="white--text" color="blue-grey lighten-1" large @click="cancel">
                        キャンセル
                    </v-btn>
                    <v-btn min-width="150px" class="white--text" color="red" large @click="pushOk"  :disabled="invalid">
                        OK
                    </v-btn>
                </v-card-actions>
            </v-card>
        </validation-observer>
    </v-dialog>
</template>

<script>
export default {
    data() {
        return {
            menu: false,
            contractEndDate: null,
            cancelNoticeDeadline: null,
            contractAlertsId: null,
            contractId: null,
            alertDateTime: null,
            note: null,
            type: 0,
            onOff: null,
        }
    },
    props: {
        item: Object,
        // ダイアログの開閉状態
        dialog: Boolean,
    },
    created() {
        this.contractAlertsId = this.item.contract_alerts_id;
        this.contractId = this.item.agreements_or_folders_id;
        this.alertDateTime = this.item.alert_datetime;
        this.note = this.item.note;
        this.type = this.item.alert_type;
        this.onOff = this.item.alert_on_off ?? 0;
        this.contractEndDate = this.item.end_date;
        this.cancelNoticeDeadline = this.item.cancel_notice_deadline;
    },
    computed: {
        handleDialog: {
            get() {
                return this.dialog;
            },
            set(value) {
                // 親コンポーネントへの通知
                this.$emit('update:dialog', value);
            }
        },
    },
    methods: {
        // ダイアログのOKボタン押下時
        pushOk() {
            let success = false;
            let message = "";
            
            axios.post('/documents/document-management/update-alert', {
                contract_id: this.contractId,
                alert_on_off: this.onOff,
                contract_alert_id: this.contractAlertsId,
                note: this.note,
                alert_type: this.type,
                alert_set_date: this.alertDateTime,
                
            }).then(res => {
                    if (res.data.success) {
                        if (res.data.contract_alert) {
                            this.contractAlertsId = res.data.contract_alert.id;
                        } else {
                            // アラートを削除した場合
                            this.contractAlertsId = null;
                            this.alertDateTime = null;
                            this.note = null;
                            this.type = 0;
                            this.onOff = null;
                            
                        }
                    }
                    success = res.data.success;
                    message = res.data.message;
                    
                }) .catch(err => {
                    success = err.data.success;
                    message = err.data.message;
                    
                }).finally(() => {
                    this.$emit("clickOk", this.contractAlertsId, this.contractId, this.alertDateTime, this.note, this.type, this.onOff, success, message);
                    this.handleDialog = false;
                });
        },
        
        // ダイアログの削除ボタン押下時
        pushDelete() {
            let success = false;
            let message = "";
            axios.post('/documents/document-management/delete-alert/' + this.contractAlertsId, {
            }).then(res => {
                    if (res.data.success) {
                        this.contractAlertsId = null;
                        this.alertDateTime = null;
                        this.note = null;
                        this.type = 0;
                        this.onOff = null;
                    }
                    success = res.data.success;
                    message = res.data.message;
                    
                }) .catch(err => {
                    success = err.data.success;
                    message = err.data.message;
                    
                }).finally(() => {
                    this.$emit("clickOk", this.contractAlertsId, this.contractId, this.alertDateTime, this.note, this.type, this.onOff, success, message);
                    this.handleDialog = false;
                });
        },
        cancel() {
            if (this.item && this.item.contract_alerts_id) {
                this.contractAlertsId = this.item.contract_alerts_id;
                this.contractId = this.item.agreements_or_folders_id;
                this.alertDateTime = this.item.alert_date;
                this.note = this.item.note;
                this.type = this.item.alert_type;
                this.onOff = this.item.alert_on_off;
            } else {
                this.alertDateTime = null;
                this.note = null;
                this.type = 0;
                this.onOff = null;
            }
            this.handleDialog = false;
        }
    },
}
</script>

<style scoped>
    .doc-info {
        margin-right: 12px;
    }
    .cancel-notice-deadline {
        padding-left: 84px;
    }
</style>